export const CHART_COLORS = {
  migrated:          "#16a34a",  // green-600
  inProgress:        "#eab308",  // yellow-500
  interrupted:       "#ef4444",  // red-500
  interruptedDelta:  "#ec4899",  // pink-500
  modified:          "#06b6d4",  // cyan-500
  notStarted:        "#94a3b8",  // slate-400
  flagged:           "#2563eb",  // blue-600
  allowed:           "#65a30d",  // lime-600
  acknowledged:      "#facc15",  // yellow-400
  skippedDuplicate:  "#a78bfa",  // violet-400
  dicom:             "#93c5fd",  // blue-300
  flaggedExtensions: "#60a5fa",  // blue-400
  over10k:           "#3b82f6",  // blue-500
  blockedByUser:     "#f59e0b",  // amber-500
  blockedByConflict: "#dc2626",  // red-600
  acknowledgedConflict: "#fb923c", // orange-400
  movedToFirmDocs:   "#16a34a",  // green-600
} as const;
